import React from "react"
import { Tabs, TabList, Tab, Text, TabPanels, TabIndicator, TabPanel } from "@chakra-ui/react"
import WClothingPanel from "./WClothingPanel"
import WAccessoriesPanel from "./WAccessoriesPanel"
import WShoesPanel from "./WShoesPanel"
import WUnderwearPanel from "./WUnderwearPanel"

const WomenTab: React.FC = () => {
  return (
    <Tabs>
      <TabList color='gray.500'>
        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Women's clothing
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Women's shoes
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Women's accessories
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Women's underwears
          </Text>
        </Tab>
      </TabList>

      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="#37A75B"
        borderRadius="1px"
      />

      <TabPanels>
        <TabPanel p={0}>
          <WClothingPanel />
        </TabPanel>

        <TabPanel p={0}>
          <WShoesPanel />
        </TabPanel>

        <TabPanel p={0}>
          <WAccessoriesPanel />
        </TabPanel>

        <TabPanel p={0}>
          <WUnderwearPanel />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

export default WomenTab